<template>
  <v-card>
    <v-container fluid>
      <v-layout wrap>
        <v-flex md6>
          <h2 v-html="title"></h2>
        </v-flex>

        <v-spacer></v-spacer>
        
        <v-flex v-if="!noSearch" md-4>
          <v-text-field
            v-model="searchQ"
            @keyup="search"
            class="search"
            outlined
            rounded
            hide-details
            :label="$t('questions-component.search-label')"
            append-icon="search"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <QuestionsList v-if="questions && questions.length > 0" :questions="questions"></QuestionsList>
          <h2 v-else>{{$t('questions-component.no-question')}}</h2>
        </v-flex>

        <v-flex xs12 sm4 offset-sm4 text-center class="links">
          <router-link to="/faq">{{ $t('questions-component.link-1') }}</router-link>
          <button class="link" @click="dialog = true">{{ $t('questions-component.link-2') }}</button>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- modal ask question -->
    <v-dialog
      v-model="dialog"
      max-width="620"
    >
      <AskHelpModal
        @dialogToParent="closeDialog"
        :dialog="dialog"
        :keywords="keywords"
        :page="page"
        :context="questionType"
        @alert="showAlert"
      ></AskHelpModal>
    </v-dialog>



    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-snackbar
      v-model="alert"
      color="#161520"
      :timeout="6000"
      top
      multi-line
    >
      <span v-html=" alertMessage"></span>
      <v-btn
        dark
        text
        :color="alertType === 'error' ? '#f12d57' : '#44d22d'"
        @click="alert = false"
      >
        {{$t('ask-box.snackbar.btn-1')}}
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
/* eslint-disable */
import QuestionsList from './QuestionsList'
import AskHelpModal from './AskHelpModal'
import HTTPresponse from '@/components/app/HTTPresponse'
import { getQuestions } from '@/js/questions/getQuestions'

export default {
  components: {
    QuestionsList: QuestionsList,
    AskHelpModal: AskHelpModal,
    HTTPresponse: HTTPresponse
  },

  props: {
    questionType: {
      type: String,
      default: () => 'all'
    },
    // keyword: {
    //   type: String,
    //   default: () => undefined
    // },
    keywords: {
      type: String,
      default: () => undefined
    },
    lang: String,
    page: {
      type: String,
      default: () => undefined
    },
    noSearch: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      title: this.questionType === 'all' ? this.$t('questions-component.title-1') :
             this.questionType === 'pending' ? this.$t('questions-component.title-2') :
             this.questionType === 'private' ? this.$t('questions-component.title-3') :
             this.questionType === 'public' ? this.$t('questions-component.title-1') : this.$t('questions-component.title-1'),
      dialog: false,

      questions: null,

      searchQ: null,

      alert: false,
      alertType: 'error',
      alertMessage: this.$t('basic-message.error-message'),

      httpalert: false
    }
  },

  async created () {
    // if (this.$store.getters['auth/isAuthenticated!']) return

    const params = {
      // keyword: this.keyword,
      keywords: this.keywords,
      lang: this.lang ? this.lang : this.$i18n.locale ? this.$i18n.locale : 'en',
      page: this.page,
      search: this.searchQ,
      key: this.$store.state.auth.token,
      questionType: this.questionType
    }

    await getQuestions(params)
      .then(response => {
        this.questions = response
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
      })
  },

  methods: {
    closeDialog (value) {
      this.dialog = value
    },

    search () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        // keyword: this.keyword,
        keywords: this.keywords,
        lang: this.lang,
        page: this.page,
        search: this.searchQ,
        key: this.$store.state.auth.token,
        questionType: this.questionType
      }

      getQuestions(params)
        .then(response => {
          this.questions = response
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    showAlert (response) {
      this.alert = true
      this.alertType = response.alertType
      this.alertMessage = response.alertMessage
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: em(20);
}
.flex {
  margin-bottom: em(30);
  &:last-child {
    margin-bottom: 0;
  }
}

.links {
  a {
    margin-right: em(30);
    &:last-child { margin-right: 0; }
  }
}
</style>
